var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index.es330.js.map
